
const ajaxCart = class extends HTMLElement {
  constructor () {
    super()
    this.open = false
    this.itemsInCart = null
    this.drawerPopup = this.closest('popup-element')
    this.initToggles()

    const activePopupId = window.localStorage.getItem('activePopup')

    if (Shopify.designMode && activePopupId === 'ajaxcart') {
      cartAPI.cart()
    }
  }

  initToggles () {
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      if (this.itemsInCart !== null && this.itemsInCart < cartData.item_count) {
        this.openAjaxcart()
      }

      this.itemsInCart = cartData.item_count
      this.freeGiftBar(cartData)
    })

    if (window.location.href.split('?')[1]?.includes('cart_redirect')) {
      this.openAjaxcart()
    }
  }

  openAjaxcart () {
    this.drawerPopup.open = true
  }

  freeGiftBar (cartData) {
    const fsb = this.querySelector('[data-fsb]')
    if (!fsb) { return }

    const threshold = parseInt(fsb.getAttribute('data-fsb'), 10) * 100
    const bar = this.querySelector('[data-fsb-bar]')
    const text = this.querySelector('[data-fsb-text]')

    if (bar !== null) {
      const barPercent = (cartData.total_price / threshold) * 100
      bar.style.width = `${barPercent > 100 ? 100 : barPercent}%`
    }

    if (text !== null) {
      text.innerHTML = cartData.total_price >= threshold
        ? text.getAttribute('data-qualified-text')
        : text.getAttribute('data-unqualified-text')
          .replace(/\[amount\]/g, Shopify.formatMoney(threshold - cartData.total_price))
    }
  }
}

if (typeof window.customElements.get('ajax-cart') === 'undefined') {
  window.customElements.define('ajax-cart', ajaxCart)
}
